import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState, useRef } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import "../../../../SignUp/onBoarding/job-title.css";

import { useCookies } from "../../../../../hooks/useCookies";
import Sidebar from "../../../../userflow/components/sidebar/sidebar";
import { useProfile } from "../../../../userflow/components/context/ProfileContext";
import { showAlert } from "../../../../../utils/alertUtils";
import * as masterConstantActions from "../../../../../actions/masterConstant";
import * as userAction from "../../../../../actions/user";

export default function KidsUpdate() {
  const { updateProfile } = useProfile();
  const [selectedHaveKids, setSelectedHaveKids] = useState(null);
  const [kidsOptions, setKidsOptions] = useState([]); // ✅ initialize as array
  const { getCookie } = useCookies();
  const navigate = useNavigate();
  const approvalstatus = getCookie("approval");
  const isFetched = useRef(false);

  const fetchHaveKids = async () => {
    try {
      const response = await masterConstantActions.getConstantHaveKids();
      if (response.status && response?.data?.length > 0) {
        setKidsOptions(response.data);
      }
    } catch (error) {
      console.error("Error fetching have kids options:", error);
    }
  };

  const fetchSelectedOptions = async () => {
    try {
      const response = await userAction.getKidsFamily();
      if (response && kidsOptions?.length > 0) {
        setSelectedHaveKids(kidsOptions[response.have_kid_id - 1]);
      }
    } catch (error) {
      console.error("Error fetching selected kids option:", error);
    }
  };

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;
    fetchHaveKids();
  }, []);

  useEffect(() => {
    if (kidsOptions?.length > 0) {
      fetchSelectedOptions();
    }
  }, [kidsOptions]);

  const saveHaveKids = async () => {
    try {
      let body = JSON.stringify({
        have_kid_id: kidsOptions.indexOf(selectedHaveKids) + 1,
      });
      const response = await userAction.UpdateKidsFamily(body);
      if (!response) {
        throw new Error("Error saving have kids option");
      }
    } catch (error) {
      console.error(error);
      showAlert("Error", "Failed to save selection");
    }
  };

  const saveAll = async () => {
    try {
      await Promise.all([saveHaveKids()]);
      await updateProfile("update");

      if (approvalstatus === "PENDING") {
        showAlert(
          "Success",
          "Approval request sent!",
          () => (window.location.href = "/user/home")
        );
      } else {
        showAlert(
          "Success",
          "Successfully updated",
          () => (window.location.href = "/user/home")
        );
      }
    } catch (error) {
      console.error("Error saving kids and family:", error);
    }
  };

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
          padding: "2rem",
        }}
      >
        <div className="job-container" style={{ overflow: "hidden" }}>
          <Container className="job-main">
            <Container className="job-content">
              <Container className="job-details">
                <div className="your-job">
                  <Container className="job-text">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="20" cy="20" r="18" fill="#4E1173" />
                      <g clipPath="url(#clip0_969_9145)">
                        <path
                          d="M18.3984 15.809C18.3359 15.7777 18.2734 15.7777 18.2109 15.7777C17.9922 15.7777 17.7734 15.9027 17.6797 16.1527C17.6172 16.2777 17.6172 16.434 17.6797 16.5902C17.7422 16.7152 17.8672 16.8402 17.9922 16.8715C18.1172 16.934 18.2734 16.934 18.4297 16.8715C18.5547 16.809 18.6797 16.684 18.7422 16.559C18.8359 16.2152 18.6797 15.9027 18.3984 15.809ZM21.8359 16.0277C21.7734 15.9965 21.7109 15.9965 21.6484 15.9965C21.5547 15.9965 21.4922 16.0277 21.4297 16.059C21.3047 16.1215 21.1797 16.2465 21.1484 16.3715C21.0547 16.6527 21.1797 16.9652 21.4922 17.0902C21.7734 17.184 22.0859 17.059 22.2109 16.7465C22.2734 16.5902 22.2734 16.4652 22.2109 16.309C22.0859 16.184 21.9609 16.0902 21.8359 16.0277ZM20.3047 17.8402C20.2109 17.8402 20.1484 17.8715 20.0859 17.934C19.8984 18.1527 19.6797 18.2465 19.3359 17.9652C19.2109 17.8715 19.0234 17.9027 18.8984 18.0277C18.8047 18.1527 18.8359 18.3402 18.9609 18.4652C19.5234 18.9027 20.0859 18.8402 20.5234 18.3402C20.6484 18.2152 20.6172 18.0277 20.4922 17.9027C20.4297 17.8715 20.3672 17.8402 20.3047 17.8402Z"
                          fill="white"
                        />
                        <path
                          d="M14.3047 11.9019L14.5234 13.4957L14.5234 13.5582L15.1797 15.5582C15.0859 15.7769 15.1172 16.0269 15.2109 16.2457C15.3047 16.4644 15.4922 16.6207 15.7109 16.7144C15.7734 18.0269 16.5234 19.2144 17.6797 19.9332C17.6484 21.3394 17.3984 22.4019 17.0234 22.9332L17.0234 22.9644C17.0234 22.9644 17.0234 22.9957 16.9922 22.9957L15.4609 26.2457C15.3984 26.4019 15.4609 26.5582 15.5859 26.6207L14.5859 28.4957C14.5234 28.6519 14.4922 28.8082 14.4922 28.9332C14.4922 29.3394 14.7422 29.7144 15.1172 29.9019C15.3672 30.0269 15.6484 30.0269 15.9297 29.9332C16.2109 29.8394 16.3984 29.6519 16.5234 29.4019L17.5234 27.5269C17.6172 27.5582 17.7422 27.4957 17.8047 27.4332C18.0859 27.0894 18.4922 26.7457 19.0547 26.3707C19.7422 25.9332 20.6172 25.9644 21.2422 26.4644C21.8359 26.9332 22.4297 27.4644 22.4297 27.4644C22.4922 27.5269 22.6172 27.5582 22.7109 27.5269L23.7109 29.3707C23.8359 29.6207 24.0547 29.8394 24.3047 29.9332C24.5859 30.0269 24.8672 30.0269 25.1172 29.9019C25.4922 29.7144 25.7422 29.3394 25.7422 28.9332C25.7422 28.7769 25.7109 28.6207 25.6484 28.4644L24.6484 26.6207C24.6797 26.5894 24.7422 26.5269 24.7422 26.4957C24.7734 26.4332 24.7734 26.3394 24.7422 26.2769L23.1172 22.9957C23.1172 22.9957 22.5234 21.5894 22.4609 19.8394C23.0234 19.4332 23.4609 18.8394 23.7109 18.1832C23.7734 18.0269 23.8672 17.7457 23.9297 17.4957C24.2109 17.4332 24.4609 17.2144 24.5859 16.9332C24.6484 16.8082 24.6484 16.6832 24.6484 16.5582C24.6797 16.5582 24.6797 16.5269 24.7109 16.5269C24.7734 16.4644 24.8359 16.3707 24.8359 16.2769C24.8359 16.2457 24.8359 15.9644 24.7734 15.6207L24.7734 15.5894L25.4297 13.5894L25.4297 13.5269L25.6797 11.9332C25.8359 11.4332 25.5859 10.8707 25.0547 10.6832C24.9297 10.6519 24.8359 10.6207 24.7109 10.6207C24.4609 10.6207 24.1797 10.7144 23.9922 10.9019C23.8984 10.9957 23.8047 11.1207 23.7422 11.2769L23.7422 11.3394L23.4922 12.8707C22.3047 11.3082 20.0859 10.1207 19.9922 10.0582C19.9922 9.99567 19.9297 9.99567 19.8672 9.99567C19.7734 9.99567 19.7109 10.0269 19.6484 10.0894C19.5547 10.1832 17.5234 12.2457 16.5859 13.3707L16.4609 12.9644L16.2109 11.3394L16.2109 11.2769C16.1484 11.1207 16.0859 10.9957 15.9609 10.9019C15.7734 10.7144 15.5234 10.6207 15.2422 10.6207C15.1172 10.6207 15.0234 10.6519 14.8984 10.6832C14.6484 10.7769 14.4297 10.9644 14.3359 11.2144C14.2422 11.4019 14.2109 11.6832 14.3047 11.9019ZM15.9609 29.1207C15.8984 29.2457 15.8047 29.3082 15.7109 29.3707C15.5859 29.4019 15.4609 29.4019 15.3672 29.3707C15.2109 29.3082 15.0859 29.1207 15.0859 28.9644C15.0859 28.9019 15.0859 28.8394 15.1172 28.7769L16.1172 26.9019L16.4922 27.0894L16.9297 27.3082L15.9609 29.1207ZM25.1172 28.9332C25.1172 29.1207 25.0234 29.2769 24.8359 29.3394C24.8047 29.3707 24.7422 29.4019 24.6797 29.4019C24.6172 29.4019 24.5859 29.4019 24.5234 29.3707C24.3984 29.3394 24.3047 29.2457 24.2422 29.1207L23.2422 27.2769L24.0859 26.8707L25.0859 28.7457C25.1172 28.8082 25.1172 28.8707 25.1172 28.9332ZM23.8984 26.3082L22.7109 26.8707L22.6797 26.8707C22.4609 26.6832 22.0547 26.3082 21.6172 25.9644C20.7734 25.2769 19.6172 25.2457 18.7109 25.8394C18.2109 26.1832 17.7734 26.5269 17.4922 26.8394L16.1484 26.2144L17.4609 23.4332L22.6484 23.4019L24.0547 26.2457L23.8984 26.3082ZM22.4297 22.8082L17.8047 22.8082C18.1172 22.0894 18.2422 21.1207 18.3047 20.2457L18.4922 20.3394L18.5234 20.3394C18.9297 20.4957 19.3359 20.5582 19.7422 20.5894C20.5234 20.6519 21.2422 20.4644 21.8672 20.1519C21.9609 21.3394 22.2422 22.2769 22.4297 22.8082ZM24.0234 16.6519C23.9609 16.7769 23.8359 16.8707 23.6797 16.8707C23.5234 16.8707 23.3984 16.9644 23.3672 17.1207C23.3359 17.3082 23.2422 17.6832 23.1484 17.9332C22.6484 19.2769 21.2734 20.0894 19.7734 19.9957C19.3984 19.9644 19.0547 19.9019 18.7109 19.7769C18.6797 19.7769 18.6797 19.7769 18.6484 19.7457C17.2422 19.2144 16.2734 17.9019 16.2734 16.4957C16.2734 16.3394 16.1484 16.2144 15.9922 16.1832C15.9922 16.1832 15.9609 16.1832 15.9297 16.1519C15.7734 16.0894 15.6797 15.9019 15.7422 15.7457L15.7422 15.6832C15.7734 15.6519 15.7734 15.6207 15.8047 15.6207C15.8359 15.5894 15.8984 15.5582 15.9609 15.5269L16.0234 15.5269C16.1172 15.5269 16.2422 15.5269 16.4297 15.4957L16.4609 15.4957C16.5547 15.4644 16.6797 15.4332 16.8047 15.4019C16.8672 15.3707 16.9297 15.3707 17.0234 15.3394L17.0547 15.3394C17.1484 15.3082 17.2109 15.2769 17.3047 15.2457C17.6797 15.0894 18.0859 14.8394 18.6172 14.4957L18.6484 14.4644C18.8047 14.5582 19.0547 14.7144 19.3359 14.8707C19.4297 14.9332 19.5547 14.9644 19.6484 15.0269L19.6797 15.0269C19.7734 15.0582 19.8984 15.1207 20.0234 15.1519L20.0547 15.1519L20.4297 15.2457L20.4922 15.2457C20.6172 15.2769 20.7734 15.3082 20.8984 15.3082C21.0547 15.3394 21.1797 15.3394 21.3359 15.3394L21.7422 15.3394C21.8047 15.3394 21.8359 15.3394 21.8984 15.3082C21.9609 15.3082 21.9922 15.3082 22.0547 15.2769C22.1172 15.2769 22.1797 15.2457 22.2109 15.2457C22.2734 15.2457 22.3047 15.2144 22.3672 15.2144C22.4297 15.2144 22.4922 15.1832 22.5234 15.1832C22.6172 15.3082 22.7422 15.4957 22.9297 15.6519C23.1172 15.8394 23.3672 16.0269 23.6484 16.1832C23.6484 16.1832 23.6797 16.1832 23.6797 16.2144L23.7109 16.2144C24.0234 16.3707 24.0859 16.5269 24.0234 16.6519ZM24.0859 13.1207L24.0859 13.0582L24.3672 11.4332C24.3984 11.3707 24.3984 11.3394 24.4609 11.3082C24.5547 11.2144 24.7422 11.1519 24.8672 11.2144C25.0859 11.2769 25.1797 11.5269 25.1172 11.7144L25.1172 11.7769L24.8672 13.3707L24.4922 14.4644C24.4609 14.3707 24.4297 14.2769 24.3672 14.1832C24.3672 14.1519 24.3359 14.1207 24.3359 14.1207L24.3359 14.0894C24.3359 14.0582 24.3047 14.0582 24.3047 14.0269L24.3047 13.9957C24.2422 13.8707 24.1484 13.7457 24.0859 13.6519C24.0547 13.5894 24.0234 13.5582 23.9922 13.4957L24.0859 13.1207ZM19.9297 10.6832C20.5547 11.0582 22.5859 12.3082 23.3672 13.7144C23.3984 13.8082 23.4922 13.9019 23.5547 13.9957C23.6172 14.0894 23.7109 14.2144 23.7422 14.3082C23.7422 14.3394 23.7734 14.3394 23.7734 14.3707C23.8984 14.5894 23.9609 14.8082 24.0234 15.0269C24.0234 15.0582 24.0234 15.0894 24.0547 15.1207C24.0859 15.1832 24.0859 15.2457 24.1172 15.3082C24.1172 15.3707 24.1484 15.4332 24.1484 15.4644L24.1484 15.7144L24.1172 15.7144C24.1172 15.7144 24.0859 15.7144 24.0859 15.6832C23.8047 15.5269 23.5859 15.3707 23.4297 15.2144C23.1797 14.9332 23.0547 14.7144 23.0547 14.7144C23.0234 14.6519 22.9609 14.5894 22.8984 14.5582C22.8359 14.5269 22.7422 14.5269 22.6797 14.5582C20.6172 15.2769 18.8984 13.8707 18.8984 13.8707C18.8672 13.8394 18.8047 13.8082 18.7422 13.8082L18.6172 13.8082C18.5859 13.8082 18.5547 13.8394 18.5547 13.8394C18.5234 13.8707 18.4922 13.8707 18.4609 13.9019C17.3984 14.6207 16.7109 14.8394 16.3672 14.9019C16.3984 14.8082 16.4297 14.6832 16.4609 14.5894C16.5234 14.4332 16.6172 14.2769 16.7109 14.1207C17.1797 13.4957 19.3359 11.3082 19.9297 10.6832ZM14.8984 11.4332C14.9297 11.3394 15.0234 11.2769 15.1172 11.2144C15.2734 11.1519 15.4297 11.1832 15.5547 11.3082C15.5859 11.3394 15.6172 11.3707 15.6484 11.4332L15.8984 13.0582L15.8984 13.1207L16.1797 13.9644C16.1484 13.9957 16.1484 14.0269 16.1172 14.0894C16.1172 14.1207 16.0859 14.1519 16.0859 14.1832C16.0547 14.2769 15.9922 14.3707 15.9609 14.4332L15.8672 14.7144C15.8672 14.7457 15.8672 14.7769 15.8359 14.7769C15.8047 14.8394 15.8047 14.9332 15.8047 14.9957L15.8047 15.0269L15.7734 15.0269C15.7422 15.0269 15.7109 15.0582 15.7109 15.0582L15.1484 13.4019L14.8984 11.8082L14.8984 11.7457C14.8359 11.6519 14.8359 11.5269 14.8984 11.4332Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_969_9145">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(10 10)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <p>What about kids?</p>
                  </Container>
                  <div
                    style={{
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <div className="job-columns">
                      {kidsOptions.map((kid) => (
                        <div
                          key={kid.id}
                          className="job-item"
                          onClick={() => setSelectedHaveKids(kid)}
                          style={{
                            backgroundColor:
                              selectedHaveKids?.id === kid.id
                                ? "#F7ECFF"
                                : "transparent",
                          }}
                        >
                          {kid.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Container>

              <div
                className="d-flex justify-content-center"
                style={{
                  position: "fixed",
                  bottom: "30px",
                  width: "100%",
                  gap: "30px",
                }}
              >
                <button
                  className="global-cancel-button"
                  onClick={() => navigate("/updateprofile")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="global-save-button"
                  onClick={saveAll}
                >
                  Save
                </button>
              </div>
            </Container>
          </Container>
        </div>
      </div>
    </Sidebar>
  );
}
